import React from "react";

const ItemsEditor = ({
    data,
    update,
    updateItem,
    addItem,
    removeItem,
    itemFields = []
}) => {
    return (
        <div className="cms-editor">

            {/* =========================================
                SECTION FIELDS
            ========================================== */}

            <label>Eyebrow</label>

            <input
                value={data.eyebrow || ""}
                onChange={e =>
                    update("eyebrow", e.target.value)
                }
            />

            <label>Title</label>

            <input
                value={data.title || ""}
                onChange={e =>
                    update("title", e.target.value)
                }
            />

            <label>Highlight</label>

            <input
                value={data.highlight || ""}
                onChange={e =>
                    update("highlight", e.target.value)
                }
            />

            <label>Description</label>

            <textarea
                value={data.description || ""}
                onChange={e =>
                    update("description", e.target.value)
                }
            />

            {/* =========================================
                ITEMS
            ========================================== */}

            {(data.items || []).map((item, index) => (
                <div
                    className="cms-item"
                    key={index}
                >

                    <div className="cms-item-header">

                        <strong>
                            Item {index + 1}
                        </strong>

                        <button
                            type="button"
                            className="cms-delete"
                            onClick={() =>
                                removeItem(index)
                            }
                        >
                            Delete
                        </button>

                    </div>

                    {itemFields.map(field => (
                        <React.Fragment key={field.key}>

                            <label>
                                {field.label}
                            </label>

                            {field.type === "textarea" ? (
                                <textarea
                                    value={
                                        item[field.key] || ""
                                    }
                                    onChange={e =>
                                        updateItem(
                                            index,
                                            field.key,
                                            e.target.value
                                        )
                                    }
                                />
                            ) : (
                                <input
                                    type={
                                        field.type || "text"
                                    }
                                    value={
                                        item[field.key] || ""
                                    }
                                    onChange={e =>
                                        updateItem(
                                            index,
                                            field.key,
                                            e.target.value
                                        )
                                    }
                                />
                            )}

                        </React.Fragment>
                    ))}

                </div>
            ))}

            {/* =========================================
                ADD ITEM
            ========================================== */}

            <button
                type="button"
                className="cms-add"
                onClick={() =>
                    addItem(
                        itemFields.reduce(
                            (item, field) => {
                                item[field.key] =
                                    field.default || "";
                                return item;
                            },
                            {}
                        )
                    )
                }
            >
                + Add Item
            </button>

        </div>
    );
};

export default ItemsEditor;